import { inboxAppUrl } from "@/config/url"

export function mountTrackableLinkMetricsPagePath (trackableLinkId: string): string {
	return `/admin/tools/trackable-links/${trackableLinkId}/metrics`
}

export function mountTrackableLinkURL (trackableLinkHash: string, trackableLinkSlug: string): string {
	return `${inboxAppUrl.trackableLinkURL}/redirect-to-whatsapp/${trackableLinkHash}/${trackableLinkSlug}`
}
